/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import {
  VolumeButton,
} from './styles';

export default function FullSoundIcon({ onClick }) {
  return (
    <VolumeButton
      viewBox="0 0 31 28"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M0 10.693V17.313C0 18.2233 0.775 18.968 1.72222 18.968H6.88889L12.555 24.413C13.64 25.4556 15.5 24.7109 15.5 23.2379V4.75155C15.5 3.27859 13.64 2.53384 12.555 3.57649L6.88889 9.038H1.72222C0.775 9.038 0 9.78275 0 10.693ZM23.25 14.003C23.25 11.0736 21.4933 8.55805 18.9444 7.33335V20.6561C21.4933 19.448 23.25 16.9324 23.25 14.003ZM18.9444 1.50774V1.83874C18.9444 2.46764 19.375 3.01379 19.9778 3.24549C24.4211 4.95015 27.5556 9.1373 27.5556 14.003C27.5556 18.8687 24.4211 23.0559 19.9778 24.7605C19.3578 24.9922 18.9444 25.5384 18.9444 26.1673V26.4983C18.9444 27.5409 20.0294 28.2691 21.0283 27.905C26.8667 25.7701 31 20.3582 31 14.003C31 7.6478 26.8667 2.23594 21.0283 0.100992C20.0294 -0.279658 18.9444 0.465092 18.9444 1.50774V1.50774Z"
          fill="white"
        />
      </g>
    </VolumeButton>
  );
}

FullSoundIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};
